<template>
  <div v-loading="loading">
    <div class="flex-between">
      <div class="title">作品批改（挑战）</div>
      <el-button style="height: 100%" size="small" @click="goBack"
        >返回列表</el-button
      >
    </div>
    <el-card shadow="hover">
      <div slot="header">
        <span class="brand-color">挑战简介</span>
      </div>
      <div class="flex">
        <div class="flex-item">
          <span class="flex-label">挑战名称：</span>
          <span>{{ projectInfo.name }}</span>
        </div>
        <div class="flex-item">
          <span class="flex-label">批改价格：</span>
          <span>¥{{ projectInfo.evaluate_price }}</span>
        </div>
      </div>
      <div class="flex">
        <div class="flex-label flex-none">选题方向：</div>
        <div class="pre-content">
          <template v-if="projectInfo.job.length">
            <div v-for="(item, index) in projectInfo.job" :key="index">
              {{ item.name }}
            </div>
          </template>
          <template v-else>
            <div>
              -
            </div>
          </template>
        </div>
      </div>
      <div class="flex">
        <div class="flex-label flex-none">作品要求：</div>
        <div>
          <div class="md-border">
            <markdown-it :md="projectInfo.project_content"></markdown-it>
          </div>
        </div>
      </div>
    </el-card>
    <el-card shadow="hover" class="require-card">
      <div slot="header" class="flex-between">
        <span class="brand-color">批改要求</span>
      </div>
      <markdown-it :md="projectInfo.require"></markdown-it>
    </el-card>
    <el-card shadow="hover" class="homework-info-card">
      <div slot="header" class="flex-between">
        <span class="brand-color">作品信息</span>
        <el-button
          size="mini"
          @click="handleDuplicateCheck"
          v-if="
            authPermissions.includes(
              'expert_service.api.fuwu_admin.v2.expert.challenges.works.duplicate'
            )
          "
          >查重
        </el-button>
      </div>
      <div class="flex">
        <div class="flex-item">
          <span class="flex-label">作品编号：</span>
          <span>{{ homeworkInfo.id }}</span>
        </div>
        <div class="flex-item">
          <span class="flex-label">学员：</span>
          <span>{{ homeworkInfo.name }}</span>
        </div>
      </div>
      <div class="flex">
        <div class="flex-item">
          <span class="flex-label">花费时间：</span>
          <span>{{ homeworkInfo.spend_time }} 小时</span>
        </div>
        <div class="flex-item">
          <span class="flex-label">提交次数：</span>
          <span>第 {{ homeworkInfo.times }} 次提交</span>
        </div>
      </div>
      <div class="flex">
        <div class="flex-item">
          <span class="flex-label">自我评价：</span>
          <el-rate
            class="homework-info-card-rate"
            v-model="homeworkInfo.self_evaluation"
            disabled
          ></el-rate>
        </div>
        <div class="flex-item">
          <span class="flex-label">挑战文件：</span>
          <el-link
            v-if="homeworkInfo.file"
            class="homework-info-card-link"
            :href="homeworkInfo.file"
            target="_blank"
            :download="homeworkInfo.file"
            :name="homeworkInfo.file"
            type="primary"
            icon="el-icon-link"
            >文件
          </el-link>
          <span v-else>没有文件</span>
        </div>
      </div>
      <div class="flex">
        <div class="flex-label flex-none">自我总结：</div>
        <div class="pre-content">{{ homeworkInfo.self_summary }}</div>
      </div>
      <div class="flex">
        <div class="flex-label flex-none">作品备注：</div>
        <div class="pre-content">{{ homeworkInfo.speak_to_teacher }}</div>
      </div>
    </el-card>
    <el-card shadow="hover" class="correct-card">
      <div slot="header" class="flex-between">
        <span class="brand-color">老师批改</span>
        <div class="correct-card-right">
          <div class="card-right-score" v-if="historyList.length > 0">
            历史得分
            <i @click="detailDrawer = true" class="el-icon-document"></i>：{{
              historyList[0].teacher_evaluate_level
            }}分
          </div>
          <el-button size="mini" @click="handleEdit" v-if="!editStatus">{{
            correcting ? "保存" : "修改"
          }}</el-button>
        </div>
        <!-- <el-button size="mini" @click="reference">批改范文</el-button> -->
      </div>
      <div
        class="correct-score-container"
        v-if="projectInfo.evaluate_type == 1 || evaluate_type > 2"
      >
        总分：
        <span class="correct-score danger-color">{{ totalScore }}</span>
      </div>
      <el-form
        class="correct-info"
        label-width="110px"
        :model="correctInfo"
        :rules="correctRules"
        ref="correctInfo"
      >
        <div v-if="projectInfo.evaluate_type == 1 || evaluate_type > 2">
          <el-form-item
            label="结果分："
            prop="resultScore"
            :show-message="false"
          >
            <zhu-slider
              class="w-95pc"
              :slider.sync="correctInfo.resultScore"
              :disabled="!correcting"
            ></zhu-slider>
          </el-form-item>
          <el-form-item label="稳定性：" prop="stability" :show-message="false">
            <zhu-slider
              class="w-95pc"
              :slider.sync="correctInfo.stability"
              :disabled="!correcting"
            ></zhu-slider>
          </el-form-item>
          <el-form-item
            label="思路分："
            prop="mentalityScore"
            :show-message="false"
          >
            <zhu-slider
              class="w-95pc"
              :slider.sync="correctInfo.mentalityScore"
              :disabled="!correcting"
            ></zhu-slider>
          </el-form-item>
          <el-form-item
            label="结构和逻辑："
            prop="structuralLogic"
            :show-message="false"
          >
            <zhu-slider
              class="w-95pc"
              :slider.sync="correctInfo.structuralLogic"
              :disabled="!correcting"
            ></zhu-slider>
          </el-form-item>
          <el-form-item
            label="规范性："
            prop="normalization"
            :show-message="false"
          >
            <zhu-slider
              class="w-95pc"
              :slider.sync="correctInfo.normalization"
              :disabled="!correcting"
            ></zhu-slider>
          </el-form-item>
        </div>
        <el-form-item v-else label="得分：" prop="total" :show-message="false">
          <el-input
            placeholder="请输入分数"
            class="w-200"
            oninput="if(!/^[0-9]+$/.test(value)) value=value.replace(/\D/g,'');if(value>100)value=100;if(value<0)value=null"
            v-model="correctInfo.total"
            :disabled="!correcting"
          >
            <template slot="append">分数</template>
          </el-input>
        </el-form-item>
        <el-form-item label="点评：" prop="review" :show-message="false">
          <Markdown
            class="w-95pc"
            :option="correcting ? 'all' : 'readmodel'"
            :value.sync="correctInfo.review"
            :defaultOpen="correcting ? 'edit' : 'preview'"
            placeholder="请输入评价"
            :disabled="correcting ? false : true"
            space="_for_fuwu_sub_project"
            folder="fuwu"
          ></Markdown>
        </el-form-item>
        <el-form-item
          label="批改用时："
          prop="correctTime"
          :show-message="false"
        >
          <el-input
            v-if="correcting"
            class="w-120"
            v-model="correctInfo.correctTime"
            placeholder="请输入数字"
            clearable
          ></el-input>
          <span v-else>{{ correctInfo.correctTime }}</span>
          分钟
        </el-form-item>
        <el-form-item label="审阅视频：">
          <el-button
            v-if="!correcting"
            size="medium"
            plain
            icon="el-icon-view"
            @click="showVideo"
            :disabled="!correctInfo.reviewVideo"
            >查看</el-button
          >
          <template v-else>
            <el-upload
              class="upload-video"
              action=""
              :before-upload="handleBeforeUpload"
              :disabled="uploadBtnLoading"
            >
              <el-button
                size="medium"
                plain
                icon="el-icon-upload"
                :loading="uploadBtnLoading"
                >上传</el-button
              >
            </el-upload>
            <el-link
              v-if="correctInfo.reviewVideo"
              :href="correctInfo.reviewVideo"
              target="_blank"
              type="primary"
              :underline="false"
              icon="el-icon-link"
              >{{ correctInfo.reviewVideoName }}
            </el-link>
          </template>
        </el-form-item>
      </el-form>
      <div class="submit-btn" v-show="correcting">
        <zhu-button
          text="提交"
          :shadow="true"
          type="primary"
          @click="submitHomework"
          :loading="btnLoading"
        ></zhu-button>
      </div>
    </el-card>
    <el-backtop></el-backtop>
    <el-dialog
      title="重复信息"
      :visible.sync="duplicateCheckVisible"
      width="720px"
      top="20vh"
      @close="duplicateCheckVisible = false"
    >
      <div>
        <el-table
          :data="duplicateCheckList"
          border
          stripe
          :loading="duplicateCheckLoading"
          size="small"
        >
          <el-table-column prop="work_id" label="作品ID" width="100">
          </el-table-column>
          <el-table-column
            prop="platform_student_name"
            label="学生信息"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="duplicate_count"
            label="相同文件数"
            width="120"
          >
          </el-table-column>
          <el-table-column prop="created_at" label="时间" width="180">
          </el-table-column>
          <el-table-column label="操作" width="100" align="center">
            <template slot-scope="scope">
              <el-popover placement="bottom" width="300" trigger="click">
                <div slot="reference">
                  <el-link
                    type="primary"
                    :underline="false"
                    @click="handleDuplicateDetail(scope.row)"
                    >详情</el-link
                  >
                </div>
                <div :loading="duplicateDetailLoading">
                  <div
                    v-if="
                      scope.row.detail &&
                        scope.row.detail.duplicate_files.length
                    "
                  >
                    <div style="font-size:16px;color:#333;margin-bottom:8px">
                      重复文件：
                    </div>
                    <span style="font-size:14px;color:#666">{{
                      scope.row.detail.duplicate_files.join("、")
                    }}</span>

                    <el-link
                      v-if="homeworkInfo.file"
                      class="homework-info-card-link ml-8"
                      :href="scope.row.detail.file_url"
                      type="primary"
                      icon="el-icon-link"
                      >下载
                    </el-link>
                  </div>
                  <div v-else>没有重复文件</div>
                </div>
              </el-popover>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <span slot="footer">
        <el-button size="small" @click="duplicateCheckVisible = false"
          >关闭</el-button
        >
      </span>
    </el-dialog>
    <el-drawer
      :visible.sync="detailDrawer"
      size="560px"
      :with-header="false"
      direction="rtl"
      :append-to-body="true"
      :modal-append-to-body="false"
    >
      <div class="detailDrawer-box" v-loading="drawerLoading">
        <div class="detailDrawer-header">
          <div>历史得分</div>
          <i class="el-icon-close" @click="detailDrawer = false"> </i>
        </div>
        <div class="detailDrawer-body">
          <div class="body-info">
            <div
              v-for="(item, index) in historyList"
              style="margin-bottom:20px"
              :key="index"
            >
              <div class="flex">
                <div class="body-top-text">
                  时间：<span style="color:rgba(0,0,0,0.85)"
                    >{{ item.teacher_evaluate_at }}
                  </span>
                </div>
                <div class="body-top-text" style="margin-left:30px">
                  得分：<span style="color:rgba(0,0,0,0.85)"
                    >{{ item.teacher_evaluate_level }}
                  </span>
                </div>
                <!-- <div class="body-content-text title">得分：</div>
                <div class="body-content-text">
                  {{ item.teacher_evaluate_level }}
                </div> -->
              </div>
              <div class="body-content">
                <!-- <div class="body-content-text title">得分：</div>
                <div class="body-content-text">
                  {{ item.teacher_evaluate_level }}
                </div> -->
                <div class="body-content-text title">点评：</div>
                <markdown-it :md="item.teacher_evaluate_comment"></markdown-it>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import { mapState } from "vuex";
import API from "@/global/request/api";
import Markdown from "@/components/Markdown";
import ZhuSlider from "@/components/ZhuSlider.vue";
import qiniuService from "@/global/service/qiniu";
import challengeService from "@/global/service/challenge";
import MarkdownIt from "@jiker/markdown-it/MarkdownIt.vue";
export default {
  components: {
    Markdown,
    ZhuSlider,
    MarkdownIt
  },
  data() {
    return {
      evaluate_type: null,
      detailDrawer: false,
      drawerLoading: false,
      historyList: [],
      currentData: {},
      loading: true,
      uploadBtnLoading: false,
      btnLoading: false,
      correcting: true,
      editStatus: false,
      duplicateCheckVisible: false,
      duplicateCheckLoading: false,
      duplicateCheckList: [],
      duplicateDetailLoading: false,
      projectInfo: {
        name: "无",
        evaluate_price: "0",
        job: [],
        project_content: "",
        evaluate_type: null
      },
      homeworkInfo: {
        id: null,
        name: "",
        spend_time: "0.00",
        times: "0",
        self_evaluation: 0,
        file: null,
        self_summary: "无",
        speak_to_teacher: "无"
      },
      correctInfo: {
        resultScore: 0,
        stability: 0,
        mentalityScore: 0,
        structuralLogic: 0,
        normalization: 0,
        review: "",
        correctTime: null,
        reviewVideo: null,
        reviewVideoId: null,
        reviewVideoName: null,
        total: null
      },
      correctRules: {
        total: { required: true, trigger: "blur" },
        resultScore: { required: true, trigger: "blur" },
        stability: { required: true, trigger: "blur" },
        mentalityScore: { required: true, trigger: "blur" },
        structuralLogic: { required: true, trigger: "blur" },
        normalization: { required: true, trigger: "blur" },
        review: { required: true, trigger: "blur" },
        correctTime: { required: true, trigger: "blur" }
      }
    };
  },
  computed: {
    ...mapState(["authPermissions"]),
    totalScore() {
      return (
        (this.correctInfo.resultScore +
          this.correctInfo.stability +
          this.correctInfo.mentalityScore +
          this.correctInfo.structuralLogic +
          this.correctInfo.normalization) /
        5
      );
    }
  },
  created() {
    this.getData();
  },
  watch: {
    $route: "getData"
  },
  methods: {
    handleDuplicateCheck() {
      this.duplicateCheckVisible = true;
      this.duplicateCheckLoading = true;
      challengeService
        .myChallengeDuplicateCheck(this.$route.params.id)
        .then(res => {
          this.duplicateCheckList = res.sort((a, b) => {
            return b.work_id - a.work_id;
          });
        })
        .finally(() => {
          this.duplicateCheckLoading = false;
        });
    },
    handleDuplicateDetail(row) {
      if (row.detail) return;
      this.duplicateDetailLoading = true;
      challengeService
        .myChallengeDuplicateDetail(this.$route.params.id, {
          compare_id: row.work_id
        })
        .then(res => {
          this.duplicateCheckList.find(
            item => item.work_id === row.work_id
          ).detail = res;
        })
        .finally(() => {
          this.duplicateDetailLoading = false;
        });
    },
    getData() {
      const id = this.$route.params.id;
      this.loading = true;
      challengeService
        .challengesWorkDetail(id)
        .then(res => {
          this.evaluate_type = res.teacher_evaluate_level_detail
            ? Object.keys(res.teacher_evaluate_level_detail).length
            : 0;
          this.correcting = res.status === 2 ? true : false;
          this.editStatus = res.status === 2 ? true : false;
          this.projectInfo.name = res.challenge.name;
          this.projectInfo.status = res.status;
          this.projectInfo.project_content = res.challenge.content;
          this.projectInfo.evaluate_price = res.teacher_evaluate_price;
          this.projectInfo.job = res.challenge.job;
          this.projectInfo.require = res.challenge.evaluate_require;
          this.projectInfo.evaluate_type = res.challenge.evaluate_type;
          this.historyList = res.work_history;
          this.homeworkInfo.id = res.id;
          this.homeworkInfo.name = res.student
            ? res.student.realname || res.student.name
            : res.source?.platform_student_name
            ? res.source.platform_student_name
            : "无";
          this.homeworkInfo.spend_time = res.student_spend_time
            ? res.student_spend_time
            : "0.00";
          this.homeworkInfo.times = res.times ? res.times : "0";
          this.homeworkInfo.self_evaluation = res.student_self_evaluation_level
            ? 6 - res.student_self_evaluation_level
            : 0;
          this.homeworkInfo.file = res.student_file_url;
          this.homeworkInfo.self_summary = res.student_self_summary
            ? res.student_self_summary
            : "无";
          this.homeworkInfo.speak_to_teacher = res.student_speak_to_teacher
            ? res.student_speak_to_teacher
            : "无";
          this.correctInfo.resultScore = res.teacher_evaluate_level_detail
            ? res.teacher_evaluate_level_detail.result * 5
            : 0;
          this.correctInfo.stability = res.teacher_evaluate_level_detail
            ? res.teacher_evaluate_level_detail.stability * 5
            : 0;
          this.correctInfo.mentalityScore = res.teacher_evaluate_level_detail
            ? res.teacher_evaluate_level_detail.thinking * 5
            : 0;
          this.correctInfo.structuralLogic = res.teacher_evaluate_level_detail
            ? res.teacher_evaluate_level_detail.logic * 5
            : 0;
          this.correctInfo.normalization = res.teacher_evaluate_level_detail
            ? res.teacher_evaluate_level_detail.normalization * 5
            : 0;
          this.correctInfo.review = res.teacher_evaluate_comment
            ? res.teacher_evaluate_comment
            : "";
          this.correctInfo.correctTime = res.teacher_evaluate_spend_time;
          this.correctInfo.reviewVideo = res.teacher_evaluate_file
            ? res.teacher_evaluate_file.path
            : null;
          this.correctInfo.total =
            res.teacher_evaluate_level_detail?.total_score ||
            res.teacher_evaluate_level;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    goBack() {
      this.$router.push({
        name: "ChallengeWorkMy"
      });
    },
    reference() {
      window.open("https://jiker.feishu.cn/docs/doccnoirKvobCFxDnKr4OfZa0nh#");
    },
    showVideo() {
      window.open(this.correctInfo.reviewVideo);
    },
    handleBeforeUpload(file) {
      if (!file || this.uploadBtnLoading) {
        return false;
      }
      const space = "_for_challenge_sub_project";
      const folder = "fuwu";
      const api = API.challengeFile;
      this.uploadBtnLoading = true;
      qiniuService
        .upload({ space, folder, file, api }, () => {})
        .then(res => {
          this.correctInfo.reviewVideo = res.url;
          this.correctInfo.reviewVideoId = res.id;
          this.correctInfo.reviewVideoName = res.name;
        })
        .finally(() => {
          this.uploadBtnLoading = false;
        });
      return false;
    },
    handleEdit() {
      if (this.correcting) {
        this.submitHomework();
        return;
      }
      this.correcting = true;
    },
    submitHomework() {
      this.$refs["correctInfo"].validate(val => {
        let params = {
          teacher_evaluate_level: this.totalScore,
          teacher_evaluate_comment: this.correctInfo.review,
          teacher_evaluate_spend_time: this.correctInfo.correctTime,
          teacher_evaluate_file_id: this.correctInfo.reviewVideoId,
          teacher_evaluate_level_detail: {}
        };
        if (this.projectInfo.evaluate_type == 1 || this.evaluate_type > 2) {
          const result = this.correctInfo.resultScore / 5;
          const stability = this.correctInfo.stability / 5;
          const thinking = this.correctInfo.mentalityScore / 5;
          const logic = this.correctInfo.structuralLogic / 5;
          const normalization = this.correctInfo.normalization / 5;
          if (!result || !stability || !thinking || !logic || !normalization) {
            this.$message.error("请确保每一项都有打分，且分数不能为零！");
            return;
          }
          if (!val) {
            this.$message.error("缺少必要参数");
            return;
          }
          params.teacher_evaluate_level_detail = {
            result,
            stability,
            thinking,
            logic,
            normalization
          };
        } else {
          if (this.correctInfo.total > 100) {
            return this.$message.warning("分数不能超过100");
          }
          params.teacher_evaluate_level_detail = {
            total_score: this.correctInfo.total
          };
          params.teacher_evaluate_level = this.correctInfo.total;
        }
        if (this.historyList.length > 0) {
          if (
            (this.projectInfo.evaluate_type == 1 &&
              params.teacher_evaluate_level_detail?.result +
                params.teacher_evaluate_level_detail?.stability +
                params.teacher_evaluate_level_detail?.thinking +
                params.teacher_evaluate_level_detail?.logic +
                params.teacher_evaluate_level_detail?.normalization <
                this.historyList[0]?.teacher_evaluate_level) ||
            (params.teacher_evaluate_level_detail.total_score <
              this.historyList[0]?.teacher_evaluate_level &&
              this.projectInfo.evaluate_type == 2)
          ) {
            this.$confirm(
              `<div style='margin-left:40px'> 本次得分低于历史评分，是否确认提交 </br> <span style='margin-top:8px'> (如确认提交请在评语中说明具体原因)</span></div>`,
              "提示",
              {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                dangerouslyUseHTMLString: true
                // type: "warning"
              }
            ).then(() => {
              this.saveHomework(params);
            });
          } else {
            this.saveHomework(params);
          }
        } else {
          this.saveHomework(params);
        }

        // if (
        //   result + stability + thinking + logic + normalization <
        //   this.historyList[0]?.teacher_evaluate_level
        // ) {
        //   this.$confirm(
        //     `<div style='margin-left:40px'> 本次得分低于历史评分，是否确认提交 </br> <span style='margin-top:8px'> (如确认提交请在评语中说明具体原因)</span></div>`,
        //     "提示",
        //     {
        //       confirmButtonText: "确定",
        //       cancelButtonText: "取消",
        //       dangerouslyUseHTMLString: true
        //       // type: "warning"
        //     }
        //   ).then(() => {
        //     const id = this.$route.params.id;
        //     this.btnLoading = true;
        //     challengeService
        //       .challengeWorksEvaluate(id, params)
        //       .then(() => {
        //         this.$message.success("提交成功");
        //         this.correcting = false;
        //         this.editStatus = false;
        //       })
        //       .finally(() => {
        //         this.btnLoading = false;
        //       });
        //   });
        // }
        // if (
        //   params.teacher_evaluate_level_detail.total_score <
        //   this.historyList[0]?.teacher_evaluate_level
        // ) {
        //   this.$confirm(
        //     `<div style='margin-left:40px'> 本次得分低于历史评分，是否确认提交 </br> <span style='margin-top:8px'> (如确认提交请在评语中说明具体原因)</span></div>`,
        //     "提示",
        //     {
        //       confirmButtonText: "确定",
        //       cancelButtonText: "取消",
        //       dangerouslyUseHTMLString: true
        //       // type: "warning"
        //     }
        //   ).then(() => {
        //     const id = this.$route.params.id;
        //     this.btnLoading = true;
        //     challengeService
        //       .challengeWorksEvaluate(id, params)
        //       .then(() => {
        //         this.$message.success("提交成功");
        //         this.correcting = false;
        //         this.editStatus = false;
        //       })
        //       .finally(() => {
        //         this.btnLoading = false;
        //       });
        //   });
        // }
      });
    },
    saveHomework(params) {
      const id = this.$route.params.id;
      this.btnLoading = true;
      challengeService
        .challengeWorksEvaluate(id, params)
        .then(() => {
          this.$message.success("提交成功");
          this.correcting = false;
          this.editStatus = false;
        })
        .finally(() => {
          this.btnLoading = false;
        });
    }
  }
};
</script>

<style lang="less" scoped>
.pre-content {
  line-height: 1.6;
  white-space: pre-wrap;
  word-break: break-all;
  word-wrap: break-word;
}
.el-form-item {
  margin-bottom: 48px !important;
}
.el-slider {
  line-height: 20px;
}
.flex {
  display: flex;
  margin-bottom: 12px;
  font-size: 14px;
  .flex-item {
    flex: 1;
  }
  .flex-none {
    flex: none;
  }
  .flex-label {
    display: inline-block;
    width: 70px;
    text-align: right;
  }
}
.homework-info-card {
  margin: 30px 0;
  .homework-info-card-rate {
    display: inline-block;
    line-height: 14px;
  }
  .homework-info-card-link {
    padding-bottom: 4px;
  }
}
.require-card {
  margin-top: 30px;
}
.correct-card {
  position: relative;
  .correct-card-right {
    display: flex;
    align-items: center;
    .card-right-score {
      font-size: 14px;
      color: rgba(0, 0, 0, 0.65);
      margin-right: 40px;
      i {
        cursor: pointer;
        &:hover {
          color: #409eff;
        }
      }
    }
  }
  .correct-score-container {
    padding: 0 20px;
    width: 100%;
    text-align: right;
    .correct-score {
      font-size: 60px;
    }
  }
  .correct-info {
    margin-top: 20px;
    .upload-video {
      display: inline-block;
      margin-right: 16px;
    }
  }
  .submit-btn {
    margin-bottom: 30px;
    text-align: center;
    .el-button {
      width: 200px;
    }
  }
}
.md-border {
  border: 1px solid #efefef;
  margin-bottom: 12px;
}
.detailDrawer-box {
  height: 100%;
  width: 100%;
  // display: flex;
  // flex-direction: column;
  // justify-content: space-between;
  .detailDrawer-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px 24px;
    border-bottom: 1px solid rgba(217, 217, 217, 1);
    div {
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: rgba(0, 0, 0, 0.85);
    }
    i {
      cursor: pointer;
    }
  }
  .detailDrawer-body {
    padding: 20px 24px;
    height: calc(100vh - 56px);
    .body-info {
      height: 100%;
      overflow-y: auto;
      .body-top-text {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.45);
      }
      .body-content {
        margin-top: 12px;
        background: #fafafa;
        padding: 16px;
        height: calc(100% - 88px);
        overflow-y: auto;
        .body-content-text {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(0, 0, 0, 0.85);
          line-height: 22px;
          margin-bottom: 18px;
          &.title {
            color: rgba(0, 0, 0, 0.45);
            margin-bottom: 10px;
          }
        }
      }
    }
  }
}
</style>
